import { render, staticRenderFns } from "./NewMicropoint.vue?vue&type=template&id=4b8e090e&scoped=true&"
import script from "./NewMicropoint.vue?vue&type=script&lang=js&"
export * from "./NewMicropoint.vue?vue&type=script&lang=js&"
import style0 from "./NewMicropoint.vue?vue&type=style&index=0&id=4b8e090e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e090e",
  null
  
)

export default component.exports